import script from "./GuestMoreMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuestMoreMenu.vue?vue&type=script&setup=true&lang=ts"

import "./GuestMoreMenu.vue?vue&type=style&index=0&id=2629ae5a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2629ae5a"]])

export default __exports__